import React from "react";
import { NavLink } from "react-router-dom";
import "../assets/styles/components/MenuInternal.sass";

const MenuPereira = () => (
  <div className="row MenuInternal --pereira">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuInternal__list">
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/tour-overview">RESUMEN</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/itinerary/start">ITINERARIO</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/package-and-price">
                PAQUETES Y PRECIO
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/upgrades-and-prices">
                ASCENSOS Y PRECIOS
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/hotels">HOTELES</NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/travel-details">
                DETALLES DEL VIAJE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <NavLink to="/coffee-mtb/important-info">
                INFORMACIÓN IMPORTANTE
              </NavLink>
            </li>
            <li className="MenuInternal__list--item">
              <a
                target="_blank"
                href="https://endurancecui.active.com/event-reg/select-race?e=87019805"
              >
                RESERVAR AHORA
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default MenuPereira;
